import FormItem from '@/components/Common/FormItem/FormItem';
import { Grid, OutlinedInput } from '@mui/material';
import { NewAddressUi } from './NewAddressUi';
import { useNewAddressViewController } from './NewAddressViewController';

export function NewAddress(props: {
  onAddressChanged: (newAddress: NewAddressUi) => void;
}) {
  const { uiState, actions } = useNewAddressViewController(
    props.onAddressChanged
  );

  return (
    <Grid container columnSpacing={'20px'} p={'16px'}>
      <Grid size={{ xs: 12, md: 6 }}>
        <FormItem
          label="Sucursal o Identificador"
          helperText={uiState.addressTagError}
        >
          <OutlinedInput
            fullWidth
            onChange={(e) => actions.onChangeAddressTag(e.target.value)}
            value={uiState.addressTag}
            error={!!uiState.addressTagError}
          />
        </FormItem>
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <FormItem label="Calle" helperText={uiState.streetError}>
          <OutlinedInput
            fullWidth
            onChange={(e) => actions.onChangeStreet(e.target.value)}
            value={uiState.street}
            error={!!uiState.streetError}
          />
        </FormItem>
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <FormItem
          label="Número exterior"
          helperText={uiState.externalNumberError}
        >
          <OutlinedInput
            fullWidth
            onChange={(e) => actions.onExternalNumberChanged(e.target.value)}
            value={uiState.externalNumber}
            error={!!uiState.externalNumberError}
          />
        </FormItem>
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <FormItem label="Número interior (opcional)">
          <OutlinedInput
            fullWidth
            onChange={(e) => actions.onInternalNumberChanged(e.target.value)}
            value={uiState.internalNumber}
          />
        </FormItem>
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <FormItem label="Código Postal" helperText={uiState.postalCodeError}>
          <OutlinedInput
            fullWidth
            onChange={(e) => actions.onPostalCodeChanged(e.target.value)}
            value={uiState.postalCode}
            error={!!uiState.postalCodeError}
          />
        </FormItem>
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <FormItem label="Colonia" helperText={uiState.coloniaError}>
          <OutlinedInput
            fullWidth
            onChange={(e) => actions.onColoniaChanged(e.target.value)}
            value={uiState.colonia}
            error={!!uiState.coloniaError}
          />
        </FormItem>
      </Grid>
    </Grid>
  );
}
